// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getLaborLocations} from '../repositories';

export const readLaborLocations = (accountId, pin, suppressErrors = false) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLaborLocations(accountId, pin, suppressErrors);

            dispatch({
                data: data.laborSubTypes,
                type: actions.UPDATE_LABOR_LOCATIONS_COLLECTION
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/labor-locations.js